export const ContainerMovementPolicy = ({

    CNTR_MOVEMENT_IB: "IB",
    CNTR_MOVEMENT_OB: "OB",
    CNTR_MOVEMENT_TS: "TS"
})